module.exports = __webpack_public_path__ + "img/img_planification_failed.2a9fbd84.svg";